import { render, staticRenderFns } from "./ProductsNew.vue?vue&type=template&id=17915c20&scoped=true"
import script from "./ProductsNew.vue?vue&type=script&lang=js"
export * from "./ProductsNew.vue?vue&type=script&lang=js"
import style0 from "./ProductsNew.vue?vue&type=style&index=0&id=17915c20&prod&lang=scss&scoped=true"
import style1 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17915c20",
  null
  
)

export default component.exports